// extracted by mini-css-extract-plugin
export default {"footer":"SmnL8y","stepActionContainer":"JAhKSS","dataMappingDetailContainer":"Byck8j"};